export const SAVED = "Saved!";
export const FAILED = "Sorry, something went wrong. No data was changed.";

export async function blockResult(response) {
  const body = await response.json().catch(() => ({}));
  const message = response.status >= 500 ? null : body && body.message;
  return { ok: response.ok, message: message || (response.ok ? SAVED : FAILED) };
}

export function requestJson({ url, method, body = null, token, fetchImpl = fetch }) {
  return fetchImpl(url, {
    method,
    body,
    credentials: "same-origin",
    headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest", "X-CSRF-Token": token },
  }).then(blockResult);
}

export function postBlockForm({ form, token, fetchImpl = fetch }) {
  return requestJson({ url: form.action, method: "POST", body: new FormData(form), token, fetchImpl });
}

export function deleteBlock({ url, token, fetchImpl = fetch }) {
  return requestJson({ url, method: "DELETE", token, fetchImpl });
}

export async function submitBlock({ button, send, notify, done }) {
  if (button.disabled) return false;
  button.disabled = true;
  try {
    const { ok, message } = await send();
    if (ok) {
      notify.success(message);
      done();
      return true;
    }
    notify.error(message);
  } catch (_error) {
    notify.error(FAILED);
  } finally {
    button.disabled = false;
  }
  return false;
}
